// Module
var code = "<div class=\"ribbon\" v-if=\"ribbonEnabled\"> <h4 v-text=\"$t('ribbon.' + ribbonEnv)\">{{ribbonEnv}}</h4> </div>";
// Exports
module.exports = code;